import { Patient } from '@/types/appointments.types';
import { Dependent } from '@/types/auth-base.types';

const wordNotToCapitalize = ['da', 'de', 'do', 'das', 'dos'];
const romanNumeral = /^(?=[IVX])X{0,3}(IX|IV|V?I{0,3})$/i;

type FormatToTitleCaseOptions = {
  keepAcronyms?: boolean;
};

const isUpperCaseWord = (word: string) => word.length > 1
  && word === word.toUpperCase()
  && word !== word.toLowerCase();

export const formatToTitleCase = (text?: string | null, { keepAcronyms = false }: FormatToTitleCaseOptions = {}) => {
  if (!text) {
    return '';
  }

  const keepUpperCaseWords = keepAcronyms && text !== text.toUpperCase();

  const words = text.split(' ');
  const titleCaseWords = words.map((word) => {
    if (wordNotToCapitalize.includes(word.toLowerCase())) {
      return word.toLowerCase();
    }
    if (romanNumeral.test(word)) {
      return word.toUpperCase();
    }
    if (keepUpperCaseWords && isUpperCaseWord(word)) {
      return word;
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });

  return titleCaseWords.join(' ');
};

export const formatClientName = (patient: Patient | Dependent) => {
  return formatToTitleCase(patient.socialName || patient.legalName);
};
